import { db } from '../connection';

export function setPincode(user, pincode) {
    return (dispatch) => {
        if(user){
            db.ref(`users/${user}/mUser_Contact/mContact_Pincode`).set(pincode);
        }
    }
}
